import type { ScheduleSortOrder } from "utils/type/schedule";

interface DatedSchedule {
  date: string;
  start_time: string;
}

/**
 * 일정을 날짜 + 시작 시간 기준으로 정렬한다. 원본 배열은 변경하지 않는다.
 * - latest: 최신순 (늦은 날짜/시간이 먼저)
 * - oldest: 오래된순 (이른 날짜/시간이 먼저)
 * date(YYYY-MM-DD) / start_time(HH:MM[:SS]) 은 문자열 비교로 시간 순서가 보장된다.
 */
export const sortSchedulesByDate = <T extends DatedSchedule>(items: T[], order: ScheduleSortOrder): T[] => {
  const direction = order === "latest" ? -1 : 1;
  return [...items].sort((a, b) => {
    const keyA = `${a.date} ${a.start_time}`;
    const keyB = `${b.date} ${b.start_time}`;
    if (keyA === keyB) return 0;
    return (keyA < keyB ? -1 : 1) * direction;
  });
};
